module.exports = __webpack_public_path__ + "static/assets/e123c351e54ccd18a193670c85291966.png";